import React from 'react';
import { ColumnsType } from 'antd/es/table';
import { formatPhoneNumber } from '../../../helpers/FunctionUtils';
import styled from 'styled-components';
import { TableEvenOdd } from '../styles';
import { CustomerType } from '../../../services/apisType';
import IcDelete from './FilterCustomers/components/IcDelete';

type SalonSmsCampaignCreateCustomerTableProps = {
  value?: CustomerType[];
  onChange?: (value: CustomerType[]) => void;
};

const SalonSmsCampaignCreateCustomerTable = ({
  value,
  onChange,
}: SalonSmsCampaignCreateCustomerTableProps) => {
  const removeCustomerByPhone = (phone: string) => {
    const newLstCustomer = value?.filter((item: CustomerType) => item.customerPhone !== phone);
    onChange && onChange(newLstCustomer || []);
  };

  const columnsCustomerSelect: ColumnsType<any> = [
    {
      title: <p>NAME</p>,
      dataIndex: 'customerName',
      className: 'name',
      render: (customerName: string) => <a>{customerName || '--'}</a>,
    },
    {
      title: 'PHONE',
      dataIndex: 'customerPhone',
      className: 'phone',
      render: (customerPhone: string) => (
        <span>{customerPhone ? formatPhoneNumber(customerPhone) : '--'}</span>
      ),
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      className: 'email',
      render: (email: string) => <span>{email || '--'}</span>,
    },
    {
      title: 'BIRTHDAY',
      dataIndex: 'birthday',
      className: 'birthday',
      render: (birthday: string) => <span>{birthday || '--'}</span>,
    },
    {
      title: 'POINT',
      dataIndex: 'point',
      className: 'point',
      render: (point: number) => <span>{point || '--'}</span>,
    },
    {
      title: 'LAST VISIT DATE',
      dataIndex: 'lastVisitedDate',
      className: 'lastVisitedDate',
      render: (lastVisitedDate: string) => <span>{lastVisitedDate || '--'}</span>,
    },
    {
      title: 'AMOUNT SPENT',
      dataIndex: 'amountSpent',
      className: 'amountSpent',
      render: (amountSpent: number) => <span>{amountSpent || '--'}</span>,
    },
    {
      title: <p>ACTION</p>,
      render: (item: CustomerType) => (
        <ButtonDelete onClick={() => removeCustomerByPhone(item.customerPhone)}>
          <IcDelete />
        </ButtonDelete>
      ),
    },
  ];

  return (
    <div>
      <TableStyled
        columns={columnsCustomerSelect}
        dataSource={value || []}
        rowKey='customerId'
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30'],
        }}
      />
    </div>
  );
};

export default SalonSmsCampaignCreateCustomerTable;

export const TableStyled = styled(TableEvenOdd)`
  thead > tr > th.ant-table-cell {
    padding: 8px 16px;
    p {
      margin: 0;
    }
  }
`;

const ButtonDelete = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;
